/**
 * When showing multiple of these issue types, sort in the order shown below
 */
export enum DataValidationIssueType {
    MISSING = 'missing',
    INVALID = 'invalid',
    MISFORMATTED = 'misformatted',
    TOO_LONG = 'too_long',
    TOO_SHORT = 'too_short',
    AI_REJECTION = 'ai_rejection'
}
